import React from "react";
import "./Ticker.css";

export default function Ticker({ items = [] }) {
    const doubled = [...items, ...items, ...items];
    return (
        <div className="ticker-wrap">
            <div className="ticker-track">
                {doubled.map((text, i) => (
                    <span key={i} className="ticker-item">{text}</span>
                ))}
            </div>
        </div>
    );
}